import { useSyncExternalStore } from "react";

const SERVER_WIDTH = 1200;

function subscribe(onChange: () => void) {
  window.addEventListener("resize", onChange);
  return () => window.removeEventListener("resize", onChange);
}

const getWidth = () => window.innerWidth;
const getServerWidth = () => SERVER_WIDTH;

export default function useWindowSize() {
  const width = useSyncExternalStore(subscribe, getWidth, getServerWidth);
  return { width, isMobile: width <= 640 };
}
